export default __webpack_public_path__ + "static/media/img_2.8eea98f9.svg";